module.exports = __webpack_public_path__ + "img/oralTest_sub32_3.4c146fa9.jpg";